import { useEffect, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import InboundETransferInfo from './InboundETransferInfo';
import useFetchInboundETransferTransaction from '@/hooks/useApi/useFetchInboundETransferTransaction';
import { useBlockingLoader } from 'shared';
import { useAlertDialog } from '@/providers/AlertDialog.provider';

type InboundETransferTransactionContainerProps = {
  TransactionID: string;
} & Omit<ComponentProps<typeof InboundETransferInfo>, 'transaction'>;

export default function InboundETransferTransactionContainer({
  TransactionID,
  isParent,
  jwt,
  ...props
}: InboundETransferTransactionContainerProps) {
  const blockingLoader = useBlockingLoader();
  const alertDialog = useAlertDialog();
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const { inboundETransferTransaction, fetchInboundETransferTransaction } = useFetchInboundETransferTransaction({
    bearer: jwt,
  });

  useEffect(() => {
    blockingLoader.show();

    fetchInboundETransferTransaction({ TransactionID })
      .catch((error) => {
        // Not returned: the dialog's promise settles on dismissal, and the loader must drop before that.
        alertDialog.error(tGlobal('error'), error instanceof Error ? error.message : tGlobal('errorOccurred'));
      })
      .finally(() => blockingLoader.hide());
  }, [TransactionID]);

  const transaction = inboundETransferTransaction?.Transactions[0];

  return (
    <div>
      {transaction && <InboundETransferInfo transaction={transaction} isParent={isParent} jwt={jwt} {...props} />}
    </div>
  );
}
